import { SvgIcon, SvgIconProps } from '@chronosphereio/chrono-ui';

export const CheckboxStripedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox="0 0 24 24" fill="none">
        <mask id="mask0_17143_25005" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse">
          <rect x="3" y="3" width="18" height="18" rx="2" fill="currentColor" />
        </mask>
        <g mask="url(#mask0_17143_25005)">
          <path
            d="M65.1551 -9.29291C65.5456 -8.90239 65.5456 -8.26924 65.1551 -7.87872L10.0007 47.2756C9.61018 47.6662 8.97703 47.6661 8.58652 47.2756C8.196 46.8851 8.196 46.252 8.58651 45.8615L63.7409 -9.29291C64.1314 -9.68342 64.7645 -9.68342 65.1551 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M59.1721 -9.29291C59.5627 -8.90239 59.5627 -8.26924 59.1721 -7.87872L4.01779 47.2756C3.62727 47.6662 2.99412 47.6661 2.60361 47.2756C2.21309 46.8851 2.21309 46.252 2.6036 45.8615L57.758 -9.29291C58.1485 -9.68342 58.7816 -9.68342 59.1721 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M53.1895 -9.29291C53.58 -8.90239 53.58 -8.26924 53.1895 -7.87872L-1.96487 47.2756C-2.35539 47.6662 -2.98854 47.6661 -3.37906 47.2756C-3.76958 46.8851 -3.76958 46.252 -3.37906 45.8615L51.7753 -9.29291C52.1658 -9.68342 52.799 -9.68342 53.1895 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M47.2068 -9.29291C47.5973 -8.90239 47.5973 -8.26924 47.2068 -7.87873L-7.94754 47.2756C-8.33806 47.6662 -8.97121 47.6661 -9.36172 47.2756C-9.75224 46.8851 -9.75224 46.252 -9.36173 45.8615L45.7926 -9.29291C46.1832 -9.68342 46.8163 -9.68342 47.2068 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M41.2239 -9.29291C41.6144 -8.90239 41.6144 -8.26924 41.2239 -7.87873L-13.9305 47.2756C-14.321 47.6662 -14.9541 47.6662 -15.3446 47.2756C-15.7352 46.8851 -15.7352 46.252 -15.3447 45.8614L39.8097 -9.29291C40.2002 -9.68342 40.8334 -9.68342 41.2239 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M35.2412 -9.29291C35.6318 -8.90239 35.6318 -8.26924 35.2412 -7.87873L-19.9131 47.2756C-20.3036 47.6662 -20.9368 47.6662 -21.3273 47.2756C-21.7178 46.8851 -21.7178 46.252 -21.3273 45.8614L33.8271 -9.29291C34.2176 -9.68342 34.8507 -9.68342 35.2412 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M29.2586 -9.29291C29.6491 -8.90239 29.6491 -8.26924 29.2586 -7.87873L-25.8958 47.2756C-26.2863 47.6662 -26.9195 47.6662 -27.31 47.2756C-27.7005 46.8851 -27.7005 46.252 -27.31 45.8614L27.8444 -9.29291C28.2349 -9.68342 28.8681 -9.68342 29.2586 -9.29291Z"
            fill="currentColor"
          />
          <path
            d="M23.2757 -9.29291C23.6662 -8.90239 23.6662 -8.26924 23.2757 -7.87873L-31.8787 47.2756C-32.2692 47.6662 -32.9024 47.6662 -33.2929 47.2756C-33.6834 46.8851 -33.6834 46.252 -33.2929 45.8614L21.8615 -9.29291C22.252 -9.68342 22.8852 -9.68342 23.2757 -9.29291Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </SvgIcon>
  );
};
